"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
require("./theme");
const typographyMixin_1 = require("./typographyMixin");
/** `Typography` is responsible for styling the text according to the designs */
exports.Typography = styled_components_1.default.div.attrs((props) => {
    var _a;
    return ({
        'data-test': (_a = props['data-test']) !== null && _a !== void 0 ? _a : 'typography',
    });
}) `
  ${typographyMixin_1.typographyMixin};
`;
exports.Typography.defaultProps = {
    size: 'sm',
    type: 'regular',
};
//# sourceMappingURL=Typography.js.map